import request from '@/utils/request'


export function websitearticles(query) {
    return request({
        url: '/website/websitehome/websitearticles',
        method: 'get',
        params: query
    })
}

export function websitearticlesById(query) {
    return request({
        url: '/website/websitehome/websitearticlesById',
        method: 'get',
        params: query
    })
}

